import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import PictureComponent from "/components/core/picture/picture-component";
import { StyledCardsComponent } from "./cards-component.scss";
const CardsComponent = ({ cardItems, showMoreText, showLessText, title })=>{
    const [showAll, setShowAll] = useState(false);
    const toggleShowAll = ()=>{
        if (showAll) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        setShowAll(!showAll);
    };
    const renderCards = ()=>{
        const visibleSets = showAll ? cardItems : cardItems.slice(0, 9);
        return visibleSets.map((set, index)=>/*#__PURE__*/ _jsxs("a", {
                href: set.pageUrl,
                className: "card",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: set.thumbnailUrl
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card-content",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "card-title",
                                children: set.title
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card-description",
                                children: set.description
                            })
                        ]
                    })
                ]
            }, index));
    };
    return /*#__PURE__*/ _jsxs(StyledCardsComponent, {
        className: "component-container",
        children: [
            title && /*#__PURE__*/ _jsx("div", {
                className: "title-wrapper",
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "cards-wrapper",
                children: renderCards()
            }),
            cardItems.length > 9 && /*#__PURE__*/ _jsx("div", {
                className: "show-more",
                onClick: toggleShowAll,
                children: showAll ? showLessText : showMoreText
            })
        ]
    });
};
export default CardsComponent;
